import React from 'react';
import {
    Box,
} from '@mui/material';

import {  useStoreActions } from 'easy-peasy';
import PageLoader from '../../../components/pageloader/pageLoader';


const PolicyText = (props) => {

    const {policyData} = props;

    const [openLoader, setOpenLoader] = React.useState(false);

    const policyContentRef = React.useRef(null);

    //const [text, setText] = React.useState('No Data');
    const [text, setText] = React.useState('');

    const policyAction = useStoreActions((actions) => actions.policy);    

    React.useEffect(() => {
        if (policyData.content && policyData.content.type && policyData.content.type === "text" && policyData.content.url) {
            setOpenLoader(true);
            let fileSrc = policyData?.content?.url;
            fetch(fileSrc).then((response) => {
                return response.text();
            })
            .then((html) => {
                setText(html); 
                setOpenLoader(false);
            }).catch(function (error) {
                setOpenLoader(false);            
                if (error?.response) {
                    if (error.response.status === 403) {
                        setText('Could not retrieve the content. Presigned url has expired')
                    }
                }
            });
        } else if(policyData.content && policyData.content.type && policyData.content.type === "url") {
            setText(policyData?.content?.url);
        }
    }, [policyAction, policyData?.content]);

    React.useEffect(() => {
        if (policyContentRef.current) {
            policyContentRef.current.innerHTML = text && text.trim().length > 0 ? text : '';

            // Force all links to open in a new tab
            const links = policyContentRef.current.querySelectorAll('a');
            links.forEach(link => {
                link.setAttribute('target', '_blank');
                link.setAttribute('rel', 'noopener noreferrer');
            });

        }
    }, [text]);

    return (
        <Box>
            {text && text.trim().length > 0 && (
                <>
                    {/*<h2 className="sectionHeading">Policy</h2>*/}
                    <div className="preview-header-section" style={{marginTop: '0'}} >
                        <PageLoader openLoader={openLoader} />
                        <div ref={policyContentRef}></div>
                    </div>
                </>
            )}
        </Box>
    )
}

export default PolicyText;